import { AccountStorage } from '@/storage/AccountStorage';
import { urlBuilder } from '@/helpers/urlBuilder';
import { SupportedLanguages, UpvestAccountStatuses } from '@/lib/contants';

export default defineNuxtRouteMiddleware((to,from)=>{
    
    if (process.server) return;
    var match = from.path.match(/^\/(de|en|fr)([\/\?].*)?$/i);
    let lang = 'en';
    if(match && match.length > 0){
        match.forEach(m=>{
            if(SupportedLanguages.indexOf(m)!=-1){
                lang = m;
            }
        })
    }
    const url = urlBuilder(lang,'/upvest-activate');
    const dashboardUrl = urlBuilder(lang,'/dashboard');
    let account = AccountStorage.getAccount();
    if(account){
        if(account.account.is_trading_available){
            let upvestAccount = AccountStorage.getUpvestAccount();
            if(upvestAccount){
                if(upvestAccount.status == UpvestAccountStatuses.active){
                    return;
                }
                else{
                    window.open(url,'_self')
                }
            }
            else{
                window.open(url,'_self')
            }
        }
        else{
            window.open(dashboardUrl,'_self')
        }
        
    }
    else{
        window.open(dashboardUrl,'_self')
    }
    
    
})